var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-delete m-1",attrs:{"small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fas fa-trash mr-2 text-twenty"}),_vm._v(" REMOVER ")])}
var staticRenderFns = []

export { render, staticRenderFns }